/* IV-ICE — theme.js */
document.addEventListener('DOMContentLoaded', function () {

  // Sync cart badge on every page load
  fetch('/cart.js')
    .then(function(r){ return r.json(); })
    .then(function(cart) {
      var badge = document.getElementById('cart-count');
      if (!badge) return;
      badge.textContent = cart.item_count;
      if (cart.item_count > 0) { badge.classList.remove('cart-badge--hidden'); }
      else { badge.classList.add('cart-badge--hidden'); }
    });

  // Header search
  var searchInput = document.getElementById('header-search-input');
  if (searchInput) {
    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' && this.value.trim()) {
        window.location.href = '/search?type=product&q=' + encodeURIComponent(this.value.trim());
      }
    });
  }

  // Novo carousel
  document.querySelectorAll('[data-novo]').forEach(initNovo);
  document.addEventListener('shopify:section:load', function(e) {
    e.target.querySelectorAll('[data-novo]').forEach(initNovo);
  });

});

// Novo carousel: one dress centred, neighbours peeking, loops forever.
// Each slide's data-pos is its distance from the centre, clamped to -2..2 (±2 = hidden).
function initNovo(root) {
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-novo-slide]'));
  var total = slides.length;
  var count = parseInt(root.getAttribute('data-count'), 10) || total;
  var current = root.querySelector('[data-novo-current]');
  var active = 0;

  function clamp(n) { return Math.max(-2, Math.min(2, n)); }
  function offset(i) {
    var off = ((i - active) % total + total) % total;
    return off > total / 2 ? off - total : off;
  }

  function render(dir) {
    slides.forEach(function(slide, i) {
      var oldPos = parseInt(slide.getAttribute('data-pos'), 10);
      var newPos = clamp(offset(i));
      var expected = clamp(oldPos - dir);

      // A slide that wraps around the loop must not slide across the centre:
      // a leaving one exits on its own side, an arriving one enters from the far side.
      if (dir && newPos !== expected) {
        if (Math.abs(newPos) === 2) {
          if (Math.abs(oldPos) < 2) { newPos = expected; }
        } else {
          slide.classList.add('is-snapping');
          slide.setAttribute('data-pos', dir > 0 ? 2 : -2);
          void slide.offsetWidth;
          slide.classList.remove('is-snapping');
        }
      }

      slide.setAttribute('data-pos', newPos);
      if (newPos === 0) { slide.removeAttribute('aria-hidden'); }
      else { slide.setAttribute('aria-hidden', 'true'); }
    });

    if (current) {
      var n = (active % count) + 1;
      current.textContent = (n < 10 ? '0' : '') + n;
    }
  }

  function go(dir) {
    active = ((active + dir) % total + total) % total;
    render(dir);
  }

  // Links in off-centre slides are not tabbable; re-applied on every move.
  function syncFocus() {
    slides.forEach(function(slide) {
      var isCentre = slide.getAttribute('data-pos') === '0';
      slide.querySelectorAll('a, button').forEach(function(el) {
        if (isCentre) { el.removeAttribute('tabindex'); }
        else { el.setAttribute('tabindex', '-1'); }
      });
    });
  }

  function move(dir) { go(dir); syncFocus(); }

  root.querySelector('[data-novo-prev]').addEventListener('click', function() { move(-1); });
  root.querySelector('[data-novo-next]').addEventListener('click', function() { move(1); });

  // Clicking a peeking neighbour brings it to the centre instead of opening it.
  slides.forEach(function(slide) {
    slide.addEventListener('click', function(e) {
      var pos = parseInt(slide.getAttribute('data-pos'), 10);
      if (pos === 1 || pos === -1) { e.preventDefault(); move(pos); }
    });
  });

  root.addEventListener('keydown', function(e) {
    if (e.key === 'ArrowLeft') { e.preventDefault(); move(-1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); move(1); }
  });

  var startX = null, startY = null;
  root.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX; startY = e.touches[0].clientY;
  }, { passive: true });
  root.addEventListener('touchend', function(e) {
    if (startX === null) return;
    var dx = e.changedTouches[0].clientX - startX;
    var dy = e.changedTouches[0].clientY - startY;
    startX = null;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { move(dx < 0 ? 1 : -1); }
  }, { passive: true });

  syncFocus();
}
